/**
 * Created by Daniel on 08/31/2019.
 * Description:
 * Add contact page
 * ------ maintenance history ------
 * 05/05/2023   Alex Xia  add event list with Ag Grid
 */

import { Component, OnInit, Input, ViewChild, ViewEncapsulation, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, HostListener, SimpleChange } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { filter, debounceTime } from 'rxjs/operators';
import { EventSettingsModel, EventRenderedArgs, ScheduleComponent, ActionEventArgs, ToolbarActionArgs, CellClickEventArgs } from '@syncfusion/ej2-angular-schedule';
import { closest } from '@syncfusion/ej2-base';
import * as _lodash from 'lodash';

import { CalendarSubChromeConfig } from './calendar-sub-chrome/calendar-sub-chrome.model';
import { CalendarLayoutActions, CalendarLayoutConfig } from './calendar-layout/calendar-layout.data';
import { CalendarListConfig } from '../../tamalelibs/components/calendar-list.config';
import { AppState, smartSelector } from '../../redux';
import { getCalendarEventsItemsState, getCalendarEventsFocusState } from '../../redux/reducers/calendar.reducer';
import { DataList } from '../../tamalelibs/models/data-list.model';
import { CalendarEntry } from '../../tamalelibs/models/calendar-entry.model';
import { CalendarScreenConfig, CalendarScreenViewType, workFlowType } from './calendar-screen.model';
import { CalendarEventsReload } from '../../redux/actions/calendar.action';
import { ThreadDetailService } from '../../services/thread-detail.service';
import { CREATE_EVENT_SUCCESS, UPDATE_EVENT_SUCCESS, DELETE_NOTE_SUCCESS, CREATE_NOTE_SUCCESS, DELETE_NOTE, DELETE_SIDENOTE_SUCCESS, DELETE_ATTACHMENT_SUCCESS, DELETE_EVENT_SUCCESS, UPDATE_NOTE_SUCCESS, UPDATE_EVENT_ADDRESS_SUCCESS, SAVE_NOTE, UPDATE_NOTE } from '../../tamalelibs/redux/note.actions';
import { RELOAD_CALENDARS } from '../../tamalelibs/redux/calendar-list.actions';
import { WebTemplateViewModel } from '../template/template-web.view-model';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { NoteDialogOpenOptions, NoteDialogType } from '../note-dialog/note-dialog.model';
import { NoteDialogService } from '../note-dialog/note-dialog.service';
import { businessConstants, LONG_TOUCH_INTERVAL, AUTO_SAVE_INTERVAL_5 } from '../../tamalelibs/constants/business.constants';
import { CalendarDialogOpenOptions, CalendarDialogType } from '../calendar-dialog/calendar-dialog.model';
import { CalendarDialogService } from '../calendar-dialog/calendar-dialog.service';
import { AlertButton, AlertBtnTypes } from '../../widgets/alert-window/alert-window.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { StoreQuerierService } from '../../services/store-querier.service';
import { userSettingSelector } from '../../redux/reducers/users.reducer';
import { UsersActionTypes } from '../../redux/actions/users.actions';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NoteService } from '../../services/note.service';
import { CalendarService } from '../../tamalelibs/services/calendar.service';
import { ColDef, GridOptions } from 'ag-grid-community';
import { CalendarScreenService } from './calendar-screen.service';
import { DEFAULT_PAGE_SIZE } from '../../widgets/grid/grid.model';
import { SlideSheetService } from '../../services/slide-sheet.service';
import { SlideSheetActionTypes, SlideSheetEventTypes } from '../slide-sheet/slide-sheet.model';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { CalendarsViewConstants } from '../../tamalelibs/models/smart-reducer.model';
import { CalendarList } from '../../tamalelibs/models/entity-list.model';
import { ToastService } from '../../widgets/toast/toast.service';
import { CalendarViewLayoutMenuConfig, CalendarViewLayoutMode } from './calendar-view-layout/calendar-view-layout.model';
import { SortInfo } from '../../pages/research/research.view-model';
import { CalendarRefinebyActions, CalendarRefinebyEvents, QueryInfo, CalendarRefinebyConfig } from '../calendar-refineby/calendar-refineby.model';
const UICOLUMNDRAGGED = 'uiColumnDragged';

@Component({
    selector: 'calendar-screen',
    templateUrl: './calendar-screen.component.html',
    styleUrls: ['./calendar-screen.component.scss',
        '../../../../node_modules/@syncfusion/ej2-base/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css',
        '../../../../node_modules/@syncfusion/ej2-angular-schedule/styles/material.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CalendarScreenComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() config: CalendarScreenConfig;
    @Input() entityID;
    @ViewChild('scheduleObj', { static: false }) scheduleObj: ScheduleComponent;

    calendarSubChromeConfig: CalendarSubChromeConfig;
    contextMenuConfig: ContextMenuConfig;
    columnDefs: Array<ColDef>;
    calendarLayoutViewMenuConfig: CalendarViewLayoutMenuConfig = new CalendarViewLayoutMenuConfig();
    calendarList = new CalendarList();
    calendarId: string = null;
    eventSettings: EventSettingsModel;
    eventList: Array<any> = [];
    filterParams = {};
    filterIcon = 'filter-o';
    gridOptions: GridOptions;
    isEntity = false;
    isFirstLoad = true;
    isShowGrid = false;
    isSwitchToGrid = false; // used to identify the case that calender view to list view or reverse
    isRefresh = false; // click refresh button ,will be show notification after refresh successfully.
    layoutConfig: CalendarLayoutConfig = new CalendarLayoutConfig(true, true);
    loadingMore = false;
    noData = false;
    page = 1;
    reloading = false;
    rowData: Array<any> = [];
    selectedTarget: Element;
    selectedIndex = 0;
    sorts: object = {};
    sortBy = 'displaydate';
    sortOrder = 'desc';
    refinebyConfig: CalendarRefinebyConfig;

    private _destroySubscriptions: Array<Subscription> = [];
    private _gridColumnApi;
    private _gridClicked = false;
    private _tooltopTemplate = '';
    private _timeoutID = null;
    // For IPAD
    private _isIPAD = false;
    private _touchStart: number;
    private _isCancelClick = false;
    private _isNavigatingViewTypeChange = false;
    // For Ag Grid
    private calendarListSubscribe$: any;
    private _gridApi;
    private _columnApi;
    private _isCollapsed = true;
    private _sortInfo: any;
    private _timer: any;
    private _userSetting;
    private _subscriptions: Array<Subscription> = [];
    private _category: Array<string>;
    private _actionPrefix: { name: string, value: string } = { name: null, value: null };
    private _queryInfo: QueryInfo = new QueryInfo();

    constructor(private _store: Store<AppState>,
        private _calendarScreenService: CalendarScreenService,
        private _threadDetailService: ThreadDetailService,
        private _noteService: NoteService,
        private _noteTemplatePageViewModel: WebTemplateViewModel,
        private _noteDialogService: NoteDialogService,
        private _calendarDialogService: CalendarDialogService,
        private _calendarService: CalendarService,
        private _alertWindow: AlertWindowService,
        private _slideSheetService: SlideSheetService,
        private _storeQuerier: StoreQuerierService,
        private _toast: ToastService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _deviceService: DeviceDetectorService,

    ) {
        this._isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    ngOnInit() {
        this.refinebyConfig = new CalendarRefinebyConfig(this._actionPrefix.name, this._actionPrefix.value);

        if (this.entityID) {
            this.isEntity = true;
            this._queryInfo.entityIds.push(this.entityID);
        }
        if (this.isShowGrid) {
            this.layoutConfig.disableCollapse = false;
            this.layoutConfig.actions$.next({
                type: CalendarLayoutActions.LAYOUT_CHANGE,
                payload: this.layoutConfig
            });
        }


        // init component
        this._initComponents();
        // loading data
        this._destroySubscriptions.push(
            this._store.pipe(
                select(this._relativeSelector(getCalendarEventsItemsState)),
                filter(data => data),
            ).subscribe(items => this._onSubscribeCalendarEventsItems(items)),

            this._noteTemplatePageViewModel.templateMsg().pipe(
                filter(res => !!res)
            ).subscribe(res => this._takeTemplateMsg(res)),

            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => {
                this._onSubscribeActionMessage(action);
            }),

            this._store.pipe(
                select(userSettingSelector),
                filter(data => data),
            ).subscribe((res) => {
                // if setting response later than get calendar, should reload get calendar after get user settings.
                if (res && this.isFirstLoad) {
                    this.isFirstLoad = false;
                    this._restoreState();
                    if (this.isShowGrid) {
                        this._reload(this._getParams(), workFlowType.INIT);
                    } else {
                        if (res.calendarPreference && res.calendarPreference.configuration) {
                            this.scheduleObj.currentView = res.calendarPreference.configuration.view;
                        }
                        this.refreshCalendar();
                    }
                    // need to sync the menu status when refresh the whole page.
                    this.calendarLayoutViewMenuConfig.layoutInfo.layoutMode = this.isShowGrid ? CalendarViewLayoutMode.Grid : CalendarViewLayoutMode.Calendar;
                    this.calendarLayoutViewMenuConfig.actions$.next(this.calendarLayoutViewMenuConfig);
                }
            }),
            this.layoutConfig.events$.subscribe(action => this._onSubscribeLayoutEvents(action)),
            this.refinebyConfig.events$.subscribe(action => this._onSubscribeRefinebyEvents(action)),
            this.calendarLayoutViewMenuConfig.events$.subscribe(event => this._calendarLayoutMenuEventHandler(event)),
            this.config.actions$.subscribe(action => this._onSubscribeActions(action)),
            this.config.events$.pipe(debounceTime(500)).subscribe(event => this._onSubscribeEvents(event))
        );
        this.refinebyConfig.actions$.next({
            type: CalendarRefinebyActions.RELOAD,
            payload: this._queryInfo
        });
        this._changeDetectorRef.detectChanges();
    }
    ngAfterViewInit() {
        this._initDataByCurrentData();
        this.refinebyConfig.actions$.next({
            type: CalendarRefinebyActions.RELOAD,
            payload: this._queryInfo
        });
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    newEvent() {
        const entity = this._storeQuerier.queryBySelector(this._relativeSelector(getCalendarEventsFocusState));
        const _calendarDialogOpenOptions = new CalendarDialogOpenOptions();
        _calendarDialogOpenOptions.openType = CalendarDialogType.NewEvent;
        _calendarDialogOpenOptions.isPluginInEditEventMode = false;
        if (!this.isShowGrid) {
            const selectedCells: Element[] = this.scheduleObj.getSelectedElements();
            const activeCellsData: CellClickEventArgs = this.scheduleObj.getCellDetails(selectedCells.length > 0 ? selectedCells : this.selectedTarget);
            _calendarDialogOpenOptions.startDate = activeCellsData ? activeCellsData.startTime : null;
            _calendarDialogOpenOptions.endDate = activeCellsData ? activeCellsData.endTime : null;
        }
        if (entity) {
            _calendarDialogOpenOptions.entity = entity;
        }
        this._calendarDialogService.dialogOpen$.next(_calendarDialogOpenOptions);
    }

    onActionBegin(args: ActionEventArgs & ToolbarActionArgs): void {
        if (args.requestType === 'toolbarItemRendering') {
            if (args.items) {
                args.items.forEach(item => {
                    if (item.type === 'Separator') {
                        item.align = 'Center';
                    }
                    switch (item.text) {
                        case 'Today':
                        case 'Day':
                        case 'Work Week':
                        case 'Week':
                        case 'Month':
                            item.align = 'Center';
                            break;
                        default:
                            break;
                    }
                });
            }
        }
    }

    onActionComplete(args: ActionEventArgs): void {
        if (args.requestType === 'viewNavigate' || args.requestType === 'toolBarItemRendered') {
            let text = 'TODAY';
            if (this.scheduleObj.currentView !== businessConstants.calendar.viewType.Day) {
                text = 'Current ' + this.scheduleObj.currentView;
            }
            document.querySelector('.e-schedule .e-schedule-toolbar .e-today .e-tbar-btn-text').innerHTML = text;
        }
    }

    onItemDoubleClick(args, data) {
        clearTimeout(this._timeoutID);
        const payload = {
            threadId: data.threadId,
            isMaximize: true,
            closeSideSheetWhenClickMiniIcon: true
        };
        this._threadDetailService.open$.next(payload);
    }

    onCreated(args): void {
        this.scheduleObj.height = window.innerHeight - 165;
        this.scheduleObj.width = '100%';

    }

    onContextMenu(args) {
        if (this.isShowGrid) {
            this.contextMenuConfig.items = [];
            this.contextMenuConfig.items.push({ id: '0', text: 'Add sidenote', disabled: false });
            if (args && args.data) {
                if (args.data.isEditable) {
                    this.contextMenuConfig.items.push({ id: '1', text: 'Edit event', disabled: false });
                }
                if (args.data.isDeletable) {
                    this.contextMenuConfig.items.push({ id: '2', text: 'Delete event', disabled: false });
                }
            }
            this.contextMenuConfig.items.push({ id: '3', text: 'Maximize view', disabled: false });
            this.contextMenuConfig.forceRefresh = true;
            this.contextMenuConfig.show$.next(new ContextMenuShowAction(args.event, args.data));
            // set style for selected row
            this._gridApi.forEachNode(function (node) {
                if (args.rowIndex === node.rowIndex) {
                    node.setSelected(true);
                } else {
                    node.setSelected(false);
                }
            });

            if (!this._changeDetectorRef['destroyed']) {
                this._changeDetectorRef.detectChanges();
            }
        } else {
            const targetElement = args.target;
            this.selectedTarget = closest(targetElement, '.e-appointment,.e-work-cells,' +
                '.e-vertical-view .e-date-header-wrap .e-all-day-cells,.e-vertical-view .e-date-header-wrap .e-header-cells');
            if (this.selectedTarget && this.selectedTarget.classList && this.selectedTarget.classList.contains('e-appointment')) {
                const event = this.scheduleObj.getEventDetails(this.selectedTarget);
                this.contextMenuConfig.items = [];
                this.contextMenuConfig.items.push({ id: '0', text: 'Add sidenote', disabled: false });
                if (event['isEditable']) {
                    this.contextMenuConfig.items.push({ id: '1', text: 'Edit event', disabled: false });
                }
                if (event['isDeletable']) {
                    this.contextMenuConfig.items.push({ id: '2', text: 'Delete event', disabled: false });
                }
                this.contextMenuConfig.items.push({ id: '3', text: 'Maximize view', disabled: false });
                this.contextMenuConfig.forceRefresh = true;
                this.contextMenuConfig.show$.next(new ContextMenuShowAction(args, event));
            } else {
                this.contextMenuConfig.items = [];
                this.contextMenuConfig.items.push({ id: '10', text: 'New event', disabled: false });
                this.contextMenuConfig.forceRefresh = true;
                this.contextMenuConfig.show$.next(new ContextMenuShowAction(args, ''));
            }
            // close the tooltip when the context menu is popuped
            this.scheduleObj.eventTooltip.close();
            if (!this._changeDetectorRef['destroyed']) {
                this._changeDetectorRef.detectChanges();
            }
        }
    }

    onDataBound() {
        if (this.scheduleObj) {
            this.scheduleObj.hideSpinner();
        }
    }

    onDataBinding(e: { [key: string]: Object }) {
        if (this.scheduleObj) {
            this.scheduleObj.showSpinner();
        }
    }

    onDisplayedColumnsChanged(event) {
        event.api.sizeColumnsToFit();
    }

    onCellClicked(args): any {
        if (args.column.getColId() !== '0') {
            this.onEventClick(args);
        }
    }

    onEventClick(args) {
        if (!this._isCancelClick) {
            clearTimeout(this._timeoutID);
            this._timeoutID = setTimeout(() => {
                const payload = {
                    eventType: 'eventClick',
                    data: args
                };
                this.config.events$.next(payload);
            }, 200);
        }
        this._isCancelClick = false;
    }

    onEventRendered(args: EventRenderedArgs) {
        const eventColor = '#D9EFFF';
        const fontColor = '#000000';
        if (!args.element) {
            return;
        }
        args.element.style.color = fontColor;
        args.element.style.backgroundColor = eventColor;
    }

    /** Initialize grid API and resize columns */
    onGridReady(params) {

        this._gridApi = params.api;
        this._gridColumnApi = params.columnApi;
        this._restoreState();
        const config = new CalendarListConfig(
            smartSelector(null, CalendarsViewConstants.ReducerName)
        );
        this._reload(this._getParams(), workFlowType.INIT);
        this._initComponentGrid(config);

        this.refinebyConfig.actions$.next({
            type: CalendarRefinebyActions.RELOAD,
            payload: this._queryInfo
        });
        this._changeDetectorRef.detectChanges();
    }

    @HostListener('window:resize', ['$event'])
    onResize(e) {
        if (!this._gridApi) {
            return;
        }
        this._gridApi.sizeColumnsToFit();
    }

    onNavigatingEvent(args) {
        if (args.action === 'date') {
            if (this.scheduleObj) {
                switch (this.scheduleObj.currentView) {
                    case businessConstants.calendar.viewType.Day:
                    case businessConstants.calendar.viewType.WorkWeek:
                    case businessConstants.calendar.viewType.Week:
                        this._handleNavigatingDateInDayOrWeekView(args);
                        break;
                    case businessConstants.calendar.viewType.Month:
                        this._handleNavigatingDateInMonth(args);
                        break;
                    default:
                        break;
                }
            }
        } else if (args.action === 'view') {
            if (args.currentView !== args.previousView) {
                // saving view type for current user
                const userSettingConfig = {
                    calendarPreference: {
                        'isCollapsed': this._isCollapsed,
                        'view': args.currentView,
                        'category': this._category
                    },
                };
                this._store.dispatch({
                    type: UsersActionTypes.UPDATE_USER_SETTING,
                    payload: userSettingConfig
                });

                this._isNavigatingViewTypeChange = true;
                if (args.currentView === businessConstants.calendar.viewType.Month) {
                    const currentViewDates = this.scheduleObj.getCurrentViewDates();
                    // Add validation to prevent errors
                    if (currentViewDates && currentViewDates.length > 0) {
                        // get the last date to avoid getting the wrong date.
                        // this.scheduleObj.getCurrentViewDates() is used to current week date, so the length of array should be 7.
                        // 0: will get the first date of the container, 6: will get the last date of the container.
                        const fisrtDayInBeforeWeek = this.scheduleObj.getCurrentViewDates()[0] || this.scheduleObj.getCurrentTime();
                        const lastDayInBeforeWeek = this.scheduleObj.getCurrentViewDates()[6] || this.scheduleObj.getCurrentTime();
                        let currentDate = fisrtDayInBeforeWeek;
                        if (fisrtDayInBeforeWeek.getMonth() !== lastDayInBeforeWeek.getMonth()) {
                            if (fisrtDayInBeforeWeek.getMonth() !== this.scheduleObj.getCurrentTime().getMonth()) {
                                currentDate = lastDayInBeforeWeek;
                            }
                        }
                        this._triggerOneMonthData(currentDate);
                    } else {
                        const currentDate = this.scheduleObj.getCurrentTime();
                        this._triggerOneMonthData(currentDate);
                    }
                } else {
                    this._scrollToDefaultTime();
                }
            }
        }
    }

    onPopupOpen(args) {
        if (args.type === 'QuickInfo' || args.type === 'Editor') {
            args.cancel = true;
        } else if (args.type === 'EventContainer') {
            args.cancel = true;
            this.scheduleObj.changeView('Day');
            this.scheduleObj.changeDate(args.data.date);
        }
    }

    onBodyScroll(e) {
        const gridBody = e.api.gridBodyCtrl.getBodyViewportElement();
        // Total scrollable height
        const gridBodyHeight = gridBody.scrollHeight;
        // Visible height
        const viewportHeight = gridBody.clientHeight;
        // Current scroll position
        const scrollTop = gridBody.scrollTop;

        if (this.calendarList && this.calendarList.next && !this.loadingMore) {
            if (scrollTop + viewportHeight + 1000 > gridBodyHeight) {
                this.loadingMore = true;
                this.page++;
                this._reload(this._getParams(), workFlowType.SCROLL);
            }
        }
    }

    onColumnVisible() {
        this._saveState();
    }

    onColumnMoved(e) {
        if (e.source === UICOLUMNDRAGGED) {
            this._saveState();
        }
    }

    onColumnResized(e) {
        if (e.source === UICOLUMNDRAGGED && e.finished) {
            this._saveState();
        }
    }

    onColumnPinned() {
        this._saveState();
    }

    onGridClick(event) {
        this._gridClicked = true;
    }

    onRowClicked(event, node?) {
        let item;
        if (node) {
            item = node;
        } else {
            item = event.api.getSelectedNodes()[0];
        }
        if (item && item.data && item.data.id) {
            if (this._gridClicked) {
                event.event['slideSheet'] = true;
                this._gridClicked = false;
            }
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.ENTITY_PANEL,
                payload: item.data.id
            });
        }
        this._onClicked(item.rowIndex);
    }

    onSortChanged(e) {
        const columnState = this._gridColumnApi.getColumnState();
        const sortModel = columnState
            .filter(column => column.sort)
            .map(column => ({ colId: column.colId, sort: column.sort }));

        if (sortModel && sortModel.length > 0) {
            this.sortBy = sortModel[0].colId;
            this.sortOrder = sortModel[0].sort;
            this.page = 1;
            this._reload(this._getParams(), workFlowType.INIT);
            if (!this._sortInfo) {
                this._sortInfo = new SortInfo();
            }
            this._sortInfo.sortBy = this.sortBy;
            this._sortInfo.sortOrder = this.sortOrder;

            // init grid status
            this._saveState();
            // trigger reload, for save screen
            this._triggerSortChanged(this._sortInfo);
        }
    }

    // For IPAD
    onTouchStart() {
        this._touchStart = new Date().getTime();
    }

    // For IPAD
    onTouchEnd(event) {
        if (this._isIPAD) {
            const touchInterval = new Date().getTime() - this._touchStart;
            if (touchInterval > LONG_TOUCH_INTERVAL) {
                event.clientX = event.pageX;
                event.clientY = event.pageY;
                this.onContextMenu(event);
                this._isCancelClick = true;
            }
        }
    }

    /**
     * show current event data count on Ag Grid
     * @returns
     */
    getRecord() {
        if (this.calendarList) {
            if (this.calendarList.totalCount === 0) {
                return StringLiteralsPipe.translate('calendar.0_record');
            } else {
                const calendarCount = this.calendarList.calendars ? this.calendarList.calendars.length : 0;
                return `${this.calendarList.totalCount} records`;
            }
        }

    }

    /**
     * reload data according to the current date
     */
    refreshCalendar() {
        if (this.isShowGrid) {
            // If user click refresh,need to load data from page 1.
            this.page = 1;
            this._reload(this._getParams(), workFlowType.INIT, true);
            this.refinebyConfig.actions$.next({
                type: CalendarRefinebyActions.RELOAD_DATA,
                payload: this._queryInfo,
            });
        } else {
            if (this.scheduleObj) {
                this.scheduleObj.showSpinner();
            }
            this._reloadDataByCurrentDate();
        }
    }

    suppressDefaultContextMenu(event) {
        // agGrid bug, we need to handle this
        event.preventDefault();
        event.stopPropagation();
    }

    private _addSideNote(data) {
        const _noteOption = new NoteDialogOpenOptions();
        const sidenoteInfo = this._noteService.getSidenoteInfoBySettingRule(data.notes, data.notesInThread);
        if (sidenoteInfo) {
            _noteOption.entryId = sidenoteInfo.entryId;
            _noteOption.entryTypeId = sidenoteInfo.entryTypeId;
        } else {
            _noteOption.entryId = data.threadId;
        }

        _noteOption.openType = NoteDialogType.AddSideNote;
        _noteOption.minimizable = true;
        _noteOption.entityFieldEditable = data.isEntityFieldEditableInSideNote;
        this._noteDialogService.dialogOpen$.next(_noteOption);
    }

    private _clearTimer(): void {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    }

    private _deleteEvent(data) {
        const content: string[] = [];
        content.push('Are you sure you want to delete this event?');
        content.push('Any attachments or sidenotes will also be deleted.');
        const cancelBtn: AlertButton = {
            text: 'Cancel',
            type: AlertBtnTypes.tertiary
        };
        const confirmButton: AlertButton = {
            text: 'Delete',
            type: AlertBtnTypes.destructive
        };

        const subscription = this._alertWindow.
            custom('Delete confirmation required', content, cancelBtn, confirmButton)
            .subscribe((result: boolean) => {
                if (result) {
                    this._store.dispatch({
                        type: DELETE_NOTE,
                        payload: {
                            id: data.threadId,
                            componentId: 'Calendar',
                        }
                    });
                }
                subscription.unsubscribe();
            });
    }

    private _editEvent(data) {
        const _noteOption = new CalendarDialogOpenOptions();
        _noteOption.openType = CalendarDialogType.EditEvent;
        _noteOption.entryId = data.threadId;
        _noteOption.isPluginInEditEventMode = false;
        _noteOption.minimizable = true;
        this._calendarDialogService.dialogOpen$.next(_noteOption);
    }

    private _getCalendarScreenViewTypeByEnum(viewType: CalendarScreenViewType) {
        switch (viewType) {
            case CalendarScreenViewType.Day:
                return 'Day';
            case CalendarScreenViewType.WorWeek:
                return 'WorkWeek';
            case CalendarScreenViewType.Week:
                return 'Week';
            case CalendarScreenViewType.Month:
                return 'Month';
            default:
                return 'Day';
        }
    }

    private _getCalendarScreenViewTypeByString(viewType: string) {
        switch (viewType.toLowerCase()) {
            case 'day':
                return 'Day';
            case 'workweek':
                return 'WorkWeek';
            case 'week':
                return 'Week';
            case 'month':
                return 'Month';
            default:
                return 'Day';
        }
    }

    private _getFirstDayInWeek(date) {
        // get the first day of the week
        if (date == null) {
            date = new Date();
        }

        const dayInWeek = date.getDay();
        const firstDayInWeek = new Date(date.getFullYear(), date.getMonth(), date.getDate() - dayInWeek);
        return firstDayInWeek;
    }

    private _getViewType() {
        let viewType = businessConstants.calendar.viewType.Month;
        const userSetting = this._storeQuerier.queryBySelector(userSettingSelector);
        if (userSetting && userSetting.calendarPreference) {
            viewType = userSetting.calendarPreference.configuration.view;
        }
        return viewType;
    }

    /**
     * used by Ag Grid of event list
     * @returns
     */
    private _getParams() {
        return {
            pageSize: DEFAULT_PAGE_SIZE,
            page: this.page,
            sortBy: this.sortBy,
            sortOrder: this.sortOrder,
            isGrid: true,
            entityId: this.entityID,
            queryInfo: this._queryInfo
        };
    }

    private _handleNavigatingDateInDayOrWeekView(args) {
        const previousDate = args.previousDate;
        const currentDate = args.currentDate;
        // get the first day of the week
        const firstDayInWeek = this._getFirstDayInWeek(currentDate);
        const firstDayInWeekSeconds = firstDayInWeek.getTime();
        // get the first day of the next week
        let firstDayInNavgatedWeekSeconds = 0;
        let firstDayInNavgatedWeek = new Date();

        firstDayInNavgatedWeekSeconds = firstDayInWeekSeconds + businessConstants.calendar.SEVENT_DAYS_IN_SECONDS;
        firstDayInNavgatedWeek = new Date(firstDayInNavgatedWeekSeconds);
        // trigger reload date
        if (!(previousDate.getTime() > firstDayInWeekSeconds &&
            previousDate.getTime() < firstDayInNavgatedWeekSeconds)) {
            this._triggerDataLoad(firstDayInWeekSeconds, firstDayInNavgatedWeekSeconds);
        }
    }

    private _handleNavigatingDateInMonth(args) {
        const currentDate = args.currentDate;
        this._triggerOneMonthData(currentDate);
    }

    private _initComponentGrid(calendarListConfig: CalendarListConfig) {
        if (!calendarListConfig) {
            calendarListConfig = new CalendarListConfig(
                smartSelector(null, CalendarsViewConstants.ReducerName)
            );
        }
        if (!this.calendarListSubscribe$) {
            this.calendarListSubscribe$ = this._store.select(calendarListConfig.rootSelector).subscribe((state) => {
                if (state) {
                    this._onSubscribeCalendarList(state);
                }
            });
            this._subscriptions.push(this.calendarListSubscribe$);
        }
        // If event changed from event detail. we need to change current item and keep check status.
        this._subscriptions.push(this._slideSheetService.slideSheetFeedbackSubject$.subscribe(res => {
            if (res.type === SlideSheetEventTypes.CALENDAR_VALUE_CHANGE) {
                this.calendarList.calendars.forEach((element, index) => {
                    if (res.payload && element.id === res.payload.id) {
                        this.calendarList.calendars[index] = res.payload;
                    }
                });
                this._gridApi.setRowData(this.calendarList.calendars);
                // reset selected row
                this._setSelectedRow(res.payload.id);
            }
        }));
        setTimeout(() => {
            this._gridApi.sizeColumnsToFit();
            this._changeDetectorRef.detectChanges();
        }, 1000);
    }

    private _initComponents() {
        this._initContextMenu();
        // set the view type
        if (this.scheduleObj) {
            this.scheduleObj.currentView = this._getCalendarScreenViewTypeByEnum(this.config.viewType);
        }
        // Init columnDefs and grid option for calendar ag-grid.
        this.columnDefs = _lodash.cloneDeep(this._calendarScreenService.columnDefs);
        this.gridOptions = this._calendarScreenService.gridOptions;
    }

    private _initContextMenu() {
        this.contextMenuConfig = new ContextMenuConfig();
        this.contextMenuConfig.single = true;
        this.contextMenuConfig.showItemIcon = false;
        this.contextMenuConfig.stateful = false;
        this.contextMenuConfig.items = [];
        this._destroySubscriptions.push(this.contextMenuConfig.events$.subscribe(event => this._onMenuSelect(event)));
    }

    private _initDataByCurrentData() {
        this.refinebyConfig.actions$.next({
            type: CalendarRefinebyActions.RELOAD,
            payload: this._queryInfo
        });
        if (this.scheduleObj) {
            // get the current week date by dafault
            const currentDate = this.scheduleObj.getCurrentTime();
            const viewType = this._getViewType();
            if (viewType === businessConstants.calendar.viewType.Month) {
                this._triggerOneMonthData(currentDate);
            } else {
                this._triggerOneWeekData(currentDate);
            }
        }


    }
    private _onSubscribeLayoutEvents(action) {
        if (action.type === CalendarLayoutActions.COLLAPSE_CHANGE) {
            this._isCollapsed = !(action.payload);
            this._saveState();
            // To handle grid column auto size
            setTimeout(() => {
                this._gridApi.sizeColumnsToFit();
            }, 1000);
        }
    }
    private _onSubscribeRefinebyEvents(action) {
        if (action.type === CalendarRefinebyEvents.UPDATE) {
            this._queryInfo.categoryFilter = action.payload.categoryFilter;
            this._queryInfo.category = action.payload.category;
            this.refinebyConfig.actions$.next({
                type: CalendarRefinebyActions.UPDATE,
                payload: this._queryInfo
            });
            this._reload(this._getParams(), workFlowType.UPDATED);
        } else if (action.type === CalendarRefinebyEvents.LOAD_REFINEBY) {

            this._queryInfo.categoryFilter = action.payload.categoryFilter;
            this._queryInfo.category = action.payload.category;
            this.refinebyConfig.actions$.next({
                type: CalendarRefinebyActions.RELOAD,
                payload: this._queryInfo
            });
        } else if (action.type === CalendarRefinebyEvents.RELOAD) {
            this._queryInfo.categoryFilter = action.payload.categoryFilter;
            this._queryInfo.category = action.payload.category;
            this.refinebyConfig.actions$.next({
                type: CalendarRefinebyActions.RELOAD,
                payload: this._queryInfo
            });
            this._reload(this._getParams(), workFlowType.UPDATED);
        } else if (action.type === CalendarRefinebyEvents.CHANGE_CATEGORY_ORDER) {
            this._category = action.payload;
            this._saveState();
        }
        this._changeDetectorRef.detectChanges();
    }


    /**
     * switch between calendar view and event list view
     * @param e
     */
    private _calendarLayoutMenuEventHandler(e) {
        if (e.type === 'CHANGE') {
            if (e.payload && e.payload.id === 1) {

                this.isSwitchToGrid = this.isShowGrid = false;
                this.layoutConfig.disableCollapse = true;
                // detect change to make sure calendar elements are loaded.
                this._changeDetectorRef.detectChanges();
                const viewType = this._getViewType();
                this.scheduleObj.currentView = this._getCalendarScreenViewTypeByString(viewType);
                this.refreshCalendar();
            } else {
                this.isSwitchToGrid = this.isShowGrid = true;
                this.layoutConfig.disableCollapse = false;
                this._changeDetectorRef.detectChanges();
            }
            this.layoutConfig.actions$.next({
                type: CalendarLayoutActions.LAYOUT_CHANGE,
                payload: this.layoutConfig
            });

            // need to save the calendar view of grid view status to server
            this._saveState();
            this.page = 1;
            this._changeDetectorRef.detectChanges();
        }
    }

    private _maximizeEventDetail(data) {
        const payload = {
            threadId: data.threadId,
            isMaximize: true
        };
        this._threadDetailService.open$.next(payload);
    }

    private _onMenuSelect(event) {
        const type = event.payload.id;
        const data = event.payload.data;
        switch (type) {
            case '0':
                this._addSideNote(data);
                break;
            case '1':
                this._editEvent(data);
                break;
            case '2':
                this._deleteEvent(data);
                break;
            case '3':
                this._maximizeEventDetail(data);
                break;
            case '10':
                this.newEvent();
                break;
            default:
                break;
        }
    }

    private _onClicked(index) {
        this.selectedIndex = index;
    }

    private _onSubscribeActionMessage(action) {
        if (this.isShowGrid) {
            if (action.type === CREATE_NOTE_SUCCESS || action.type === CREATE_EVENT_SUCCESS || action.type === UPDATE_EVENT_SUCCESS || action.type === DELETE_EVENT_SUCCESS) {
                this.page = 1;
                this._reload(this._getParams(), workFlowType.UPDATED);
                this.refinebyConfig.actions$.next({
                    type: CalendarRefinebyActions.UPDATE,
                    payload: this._queryInfo
                });
            }
        } else {
            if (action.type === DELETE_ATTACHMENT_SUCCESS ||
                action.type === DELETE_EVENT_SUCCESS ||
                action.type === DELETE_NOTE_SUCCESS ||
                action.type === DELETE_SIDENOTE_SUCCESS ||
                action.type === UPDATE_EVENT_ADDRESS_SUCCESS) {
                this._reloadDataByCurrentDate();
            }
        }
    }

    private _onSubscribeActions(action) {
        if (action.type === 'RELOAD') {
            this._initDataByCurrentData();
        }
    }
    private _onSubscribeCalendarList(state) {
        if (state && state.items && state.items.calendarList && state.items.calendarList.calendars && state.items.calendarList.calendars.length > 0) {
            if (this.calendarList !== state.items.calendarList) {
                this.calendarList = state.items.calendarList;
                if (this.isRefresh) {
                    const notification: NotificationOptions = {
                        message: StringLiteralsPipe.translate('calendar.calendar_list_is_refreshed'),
                        style: NotificationStyles.Info

                    };
                    this._toast.notify(notification);
                }
                if (this._gridApi) {
                    this._postReload(state.items.params);
                }
            }

        } else {
            this._gridApi.setRowData([]);
            if (this.calendarList) {
                this.calendarList.totalCount = 0;
            }
            this.noData = true;
            this.reloading = false;
        }
        this._changeDetectorRef.detectChanges();
    }

    private _onSubscribeCalendarEventsItems(eventList: DataList<CalendarEntry>) {
        const dataSource = this._mapCalendarList(eventList);
        this._prepareTooltipTemplate();
        this.eventSettings = { dataSource: dataSource, enableTooltip: this._isIPAD ? false : true, tooltipTemplate: this._tooltopTemplate };
        if (!this._isNavigatingViewTypeChange) {
            this._changeView();
        }
        this._isNavigatingViewTypeChange = false;
        if (this.scheduleObj) {
            this._scrollToDefaultTime();
            this.scheduleObj.hideSpinner();
        }
        if (!this._changeDetectorRef['destroyed']) {
            this._changeDetectorRef.detectChanges();
        }
    }

    private _changeView() {
        if (this.scheduleObj) {
            // set the view type
            const viewType = this._getViewType();
            if (viewType !== this.scheduleObj.currentView) {
                this.scheduleObj.changeView(this._getCalendarScreenViewTypeByString(viewType));
            }
        }
    }
    private _onSubscribeEvents(param) {
        if (param.eventType === 'eventClick') {
            const payload = {
                threadId: this.isShowGrid ? param.data.data.threadId : param.data.event.threadId,
                isMaximize: false
            };
            this._threadDetailService.open$.next(payload);
        }
    }

    private _prepareAction(action: any, prefix: string, instanceId: string) {
        if (action && prefix && instanceId) {
            action[prefix] = instanceId;
        }
        return action;
    }

    private _prepareTooltipTemplate() {
        this._tooltopTemplate = '<div class="tooltip-wrap">' +
            '<div class="item-row first">' +
            '<div class="subject-area">' +
            '<span class="subject-value">${Subject}</span>' +
            '</div>' +
            '</div>' +
            '<div class="item-row second">' +
            '<div class="entities-area">' +
            '${EntityElements}' +
            '</div>' +
            '</div>' +
            '<div class="item-row third">' +
            '<div class="entry-type-area">' +
            '<span class="entry-type-value">${EntryType.name}</span>' +
            '</div>' +
            '</div>' +
            '<div class="item-row fouth">' +
            '<div class="date-area">' +
            '<img src="./assets/images/singlesvg/calendar.svg" class="date"></img>' +
            '<span class="date-value">${dateElement}</span>' +
            '</div>' +
            '</div>' +
            '<div class="item-row fifth">' +
            '<div class="particpants-area">' +
            '<img src="./assets/images/singlesvg/particpants.svg" class="particpants"></img>' +
            '<span class="particpants-values">${AttendeesNumber} particpants</span>' +
            '</div>' +
            '</div>' +
            '<div class="item-row sixth">' +
            '<div class="location-area">' +
            '<img src="./assets/images/singlesvg/location.svg" class="location-icon"></img>' +
            '<span class="location-value">${locationShowInTooltip}</span>' +
            '</div>' +
            '</div>' +
            '</div>';
    }

    /**
     * map calendar list to fit for Ag Grid columns
     * @param eventList
     * @returns
     */
    private _mapCalendarList(eventList: any) {
        const dataSource = [];
        let entityArray = [];
        if (eventList && eventList.length > 0) {
            eventList.forEach(item => {
                const attendeeContainer = [];
                if (item.Attendees) {
                    item.Attendees.forEach(attendee => {
                        attendeeContainer.push(attendee['short-name']);
                    });
                }
                const attendees = attendeeContainer.join('; ');
                const attendeesNumber = attendeeContainer.length;
                // create entity element for tooltip
                let entityInTooltip = '';
                if (item.entitiesInfo) {
                    entityArray = item.entitiesInfo.split(';');
                    if (entityArray && entityArray.length > 0) {
                        entityArray.forEach(entity => {
                            entityInTooltip = entityInTooltip + '<span class="entities-value">' + entity + '</span>';
                        });
                    }
                }
                // create date delement for tooltip
                let dateInTooltip = '';
                if (item && item.EndDate) {
                    dateInTooltip = this._threadDetailService.getCalendarDateInfo(item.AllDay, item.displayDate, item.EndDate.getTime());
                }
                // TAM-27797:Two all days event should take up two columns for display in event dashboard list
                if (item.AllDay) {
                    item.EndDate = new Date(item.EndDate.getTime() + 86400000);
                }
                // whether the event show on the top of the calendar
                let isShowOnTop = false;
                if (item && item.EndDate && item.displayDate) {
                    if (item.EndDate.getTime() - item.displayDate.getTime() > 86400000) {
                        isShowOnTop = true;
                    }
                }
                let locationShowInTooltip = item.Location;
                if (item && item.Location && item.LocationExpand && item.LocationExpandValue) {
                    const locationExpandObj = JSON.parse(item.LocationExpand);
                    if (locationExpandObj.linkedEntityId &&
                        item.LocationExpandValue.linkedEntityLongName &&
                        item.LocationExpandValue.linkedEntityLongName !== businessConstants.common.noPermissioIdentifier) {
                        locationShowInTooltip = this._calendarService.generateDisplayLocation(item.LocationExpandValue.linkedEntityLongName, locationExpandObj.addressName, item.Location);
                    }
                }
                dataSource.push({
                    id: item.id,
                    Subject: item.calculatedSubject,
                    StartTime: item.displayDate,
                    EndTime: item.EndDate,
                    EntityElements: entityInTooltip,
                    Entities: item.entitiesInfo,
                    threadId: item.parentEntryID,
                    dateElement: dateInTooltip,
                    Attendees: attendees,
                    AttendeesNumber: attendeesNumber,
                    Location: item.Location,
                    locationShowInTooltip: locationShowInTooltip,
                    isEntityFieldEditableInSideNote: item.isEntityFieldEditableInSideNote,
                    isAllDay: item.AllDay,
                    isEditable: item.editable,
                    isDeletable: item.deletable,
                    notesInThread: item.notesInThread,
                    attachmentsInThread: item.attachmentsInThread,
                    EntryType: item.entryType,
                    isShowOnTop: isShowOnTop,
                    notes: item.notes
                });
            });
        }
        return dataSource;
    }

    private _postReload(params: any) {
        // Assign the datasource for ag-grid
        if (this.calendarList && this.calendarList.calendars && this.calendarList.calendars.length > 0) {
            const calendarListData = this._mapCalendarList(this.calendarList.calendars);

            if (!this.reloading && !this.loadingMore) {
                this._gridApi.setRowData(calendarListData);
            }
            if (this.reloading) {
                this._gridApi.setRowData(calendarListData);
                this.reloading = false;
                const scrollIndex = (this.page - 1) * DEFAULT_PAGE_SIZE + 1;
                this._gridApi.ensureIndexVisible(scrollIndex);
            }
            if (this.loadingMore) {
                this.loadingMore = false;
                const startRowIndex = (this.page - 1) * DEFAULT_PAGE_SIZE;
                const endRowIndex = this.page * DEFAULT_PAGE_SIZE;
                this._gridApi.updateRowData({
                    add: calendarListData.slice(startRowIndex, endRowIndex)
                });
            }

        } else {
            this._gridApi.setRowData([]);
            this.calendarId = null;
        }
        this.reloading = false;
        // To handle the scroll bar below the first load
        setTimeout(() => {
            this._gridColumnApi.autoSizeAllColumns();
            this._changeDetectorRef.detectChanges();
        }, 1000);
    }
    private _relativeSelector(selector) {
        return (state) => {
            return selector(smartSelector(this.config.instanceId, 'calendarReducer')(state));
        };
    }

    private _reloadDataByCurrentDate() {
        if (this.scheduleObj) {
            let currentDate = this.scheduleObj.getCurrentViewDates()[0] || this.scheduleObj.getCurrentTime();
            switch (this.scheduleObj.currentView) {
                case businessConstants.calendar.viewType.Day:
                case businessConstants.calendar.viewType.WorkWeek:
                case businessConstants.calendar.viewType.Week:
                    this._triggerOneWeekData(currentDate);
                    break;
                case businessConstants.calendar.viewType.Month:
                    currentDate = this.scheduleObj.getCurrentViewDates()[15] || this.scheduleObj.getCurrentTime();
                    this._triggerOneMonthData(currentDate);
                    break;
                default:
                    break;
            }
        }
    }

    /**
     * reload event list in Ag Grid
     * @param conditions
     * @param workflow
     * @param isRefresh
     * @returns
     */
    private _reload(conditions, workflow, isRefresh = false) {
        if (!this._userSetting) {
            this._store.dispatch({
                type: UsersActionTypes.LOAD_USER_SETTING
            });
            return;
        }
        if (workflow !== workFlowType.SCROLL) {
            this.reloading = true;
        }
        this.isRefresh = isRefresh;
        const action = this._prepareAction({
            type: RELOAD_CALENDARS,
            payload: Object.assign({ workflow: workflow }, conditions)
        }, '', this.config.instanceId);
        this._store.dispatch(action);
    }

    /**
     * reset column status by store for Ag Grid as well as isShowGrid status
     */
    private _restoreState() {
        this._userSetting = this._storeQuerier.queryBySelector(userSettingSelector);
        if (this._userSetting && this._userSetting.calendarListColumn && this._userSetting.calendarListColumn.configuration && this._userSetting.calendarListColumn.configuration.setting) {
            const a = this._userSetting.calendarListColumn.configuration.setting;
            if (this._gridColumnApi) {
                this._gridColumnApi.applyColumnState({ state: a });
            }
        }

        if (this._userSetting && this._userSetting.calendarPreference && this._userSetting.calendarPreference.configuration) {
            this.isShowGrid = this.isSwitchToGrid || this._userSetting.calendarPreference.configuration.isShowGrid || false;
            this._isCollapsed = this._userSetting.calendarPreference.configuration.isCollapsed;
            this.layoutConfig.isCollapsed = this._userSetting.calendarPreference.configuration.isCollapsed;
            this._category = this._userSetting.calendarPreference.configuration.category;
            if (this.isShowGrid) {
                this.layoutConfig.disableCollapse = false;
            } else {
                this.layoutConfig.disableCollapse = true;
            }
            this.layoutConfig.actions$.next({
                type: CalendarLayoutActions.LAYOUT_CHANGE,
                payload: this.layoutConfig
            });
        }

        if (this._userSetting && this._userSetting.calendarListSort && this._userSetting.calendarListSort.configuration && this._userSetting.calendarListSort.configuration.sortInfo) {
            this._sortInfo = this._userSetting.calendarListSort.configuration.sortInfo;
            if (this._sortInfo) {
                const sort = [
                    {
                        colId: this._sortInfo.sortBy,
                        sort: this._sortInfo.sortOrder
                    }
                ];
                if (this._gridApi) {
                    this._gridColumnApi.applyColumnState({ state: sort });
                }
            }
        } else {
            // set default sort
            const sort = [
                {
                    colId: this.sortBy,
                    sort: this.sortOrder
                }
            ];
            if (this._gridColumnApi) {
                this._gridColumnApi.applyColumnState({ state: sort });
            }
        }
        this._changeDetectorRef.detectChanges();
    }

    /**
     * save column setting by to server and store.
     * @param column
     */
    private _saveState() {
        let userSettingConfig = {};
        if (this._gridColumnApi) {
            const gridColumns = this._gridColumnApi.getColumnState();
            userSettingConfig = {
                calendarListColumn: {
                    'setting': gridColumns,
                },
                calendarPreference: {
                    'isShowGrid': this.isShowGrid,
                    'isCollapsed': this._isCollapsed,
                    'view': this._getViewType(),
                    'category': this._category
                }
            };
        }
        this._clearTimer();
        this._timer = setTimeout(() => {
            this._store.dispatch({
                type: UsersActionTypes.UPDATE_USER_SETTING,
                payload: userSettingConfig
            });
        }, AUTO_SAVE_INTERVAL_5);
    }

    private _takeTemplateMsg(msg: string) {
        if (msg.indexOf(CREATE_EVENT_SUCCESS) > -1 ||
            msg.indexOf(CREATE_NOTE_SUCCESS) > -1 ||
            msg.indexOf(UPDATE_EVENT_SUCCESS) > -1 ||
            msg.indexOf(UPDATE_NOTE_SUCCESS) > -1 ||
            msg.indexOf(UPDATE_EVENT_ADDRESS_SUCCESS) > -1) {
            this._reloadDataByCurrentDate();
        }
    }

    private _triggerDataLoad(startDate, endDate, isGrid = false) {
        const entity = this._storeQuerier.queryBySelector(this._relativeSelector(getCalendarEventsFocusState));

        this.refinebyConfig.actions$.next({
            type: CalendarRefinebyActions.RELOAD,
            payload: this._queryInfo
        });

        const payload = {
            entityId: entity == null ? '' : entity.id,
            startDate: startDate,
            endDate: endDate,
            isGrid: isGrid,
            pageIndex: this.page,
            pageSize: DEFAULT_PAGE_SIZE,
        };
        this._store.dispatch(new CalendarEventsReload(payload, this.config.prefix, this.config.instanceId));

        this._changeDetectorRef.detectChanges();
    }

    private _triggerOneWeekData(currentDate) {
        // get the first day of the week
        const firstDayInWeekDate = this._getFirstDayInWeek(currentDate);
        const firstDayInWeekSeconds = firstDayInWeekDate.getTime();
        // get the first day of the navgated week
        const firstDayInNavgatedWeekSeconds = firstDayInWeekSeconds + businessConstants.calendar.SEVENT_DAYS_IN_SECONDS;

        this._triggerDataLoad(firstDayInWeekSeconds, firstDayInNavgatedWeekSeconds);
    }

    private _triggerOneMonthData(currentDate) {
        if (currentDate instanceof Date) {
            const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getTime();
            const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).getTime();
            this._triggerDataLoad(startDate, endDate);
        }
    }

    /**
     * save sort change to server and store
     * @param sortInfo
     */
    private _triggerSortChanged(sortInfo: SortInfo) {
        const userSettingConfig = {
            calendarListSort: {
                sortInfo
            },
        };
        this._store.dispatch({
            type: UsersActionTypes.UPDATE_USER_SETTING,
            payload: userSettingConfig
        });
    }

    private _setSelectedRow(selectedId: string): void {
        this.gridOptions.api.forEachNode(node => {
            if (node.data.id === selectedId) {
                node.setSelected(true);
            }
        });
    }

    private _scrollToDefaultTime() {
        setTimeout(() => {
            if (this.scheduleObj) {
                this.scheduleObj.scrollTo(businessConstants.calendar.defaultScrollTime);
            }
        }, 250);
    }
}
